export default {
  UPDATE_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
  },
};
